export enum CSS_VARS {
	CARD_SPACE = 'card-space'
}
